<template>
  <div class="step-four">
    <div v-if="eventType === 2" class="visit-form-content">
      <van-collapse v-model="activeNames">
        <van-collapse-item :title="$t('shared.title.preparations')" name="1">
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.preEventWarmUpCooperation') }}</span>
            </div>
            <XuSelect v-model="eventSd.warmUp" :dataOptions="warmUpList" />
          </div>
        </van-collapse-item>
        <van-collapse-item :title="$t('shared.title.estimationOfResults')" name="2">
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.eventSellInStoreTarget') }}</span>
            </div>
            <van-field v-model="eventSd.sellInStoreCount" placeholder="" :border="false" class="custom-field" />
          </div>
          <div class="top-title">
            <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
            <div>{{ $t('form.salesReorderForecast') }}</div>
          </div>
          <div class="form-item" v-for="(brandItem) in eventSd.projectSalePredict" :key="brandItem.projectId">
            <div class="label square">
              <span>{{ brandItem.projectName }}</span>
            </div>
            <div class="brand-item">
              <div class="product-listing">
                <div class="listing-product">
                  <div class="quantity-item">
                    <div class="title">{{ $t('shared.salesPcsWeek') }}</div>
                    <div class="stepper-custom">
                      <div class="step-btn" @click="handleStep(-5, brandItem, 'sales')">-5</div>
                      <div class="step-btn" @click="handleStep(-1, brandItem, 'sales')">-</div>
                      <van-field class="step-value" v-model.number="brandItem.sales" type="digit" :border="false" />
                      <div class="step-btn" @click="handleStep(1, brandItem, 'sales')">+</div>
                      <div class="step-btn" @click="handleStep(5, brandItem, 'sales')">+5</div>
                    </div>
                  </div>
                  <div class="quantity-item">
                    <div class="title">{{ $t('shared.reorderPcs') }}</div>
                    <div class="stepper-custom">
                      <div class="step-btn" @click="handleStep(-5, brandItem, 'inventory')">-5</div>
                      <div class="step-btn" @click="handleStep(-1, brandItem, 'inventory')">-</div>
                      <van-field class="step-value" v-model.number="brandItem.inventory" type="digit" :border="false" />
                      <div class="step-btn" @click="handleStep(1, brandItem, 'inventory')">+</div>
                      <div class="step-btn" @click="handleStep(5, brandItem, 'inventory')">+5</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div v-else>
      <div class="form-item">
        <div class="label">{{ $t('form.supportsPreEventInStoreDisplay') }}</div>
        <van-field class="custom-field custom-radio-field">
          <template #input>
            <van-radio-group v-model="formFourData.isPreStore" :disabled="isDisable" direction="horizontal">
              <van-radio v-for="(subItem, subIndex) in radioList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
      <div class="form-item">
        <div class="label">{{ $t('form.warmUp') }}</div>
        <van-field class="custom-field custom-radio-field">
          <template #input>
            <van-radio-group v-model="formFourData.isWarmUp" :disabled="isDisable" direction="horizontal">
              <van-radio v-for="(subItem, subIndex) in radioList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
      <div class="form-item">
        <div class="label">{{ $t('form.warmUpType') }}</div>
        <van-field v-model="formFourData.warmUpType" placeholder="" :disabled="isDisable" :border="false" class="custom-field" />
      </div>
      <div class="form-item">
        <div class="label">{{ $t('form.daysInAdvance') }}</div>
        <van-field v-model="formFourData.advanceDay" placeholder="" :disabled="isDisable" type="digit" :border="false" class="custom-field" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isDisable: {
      type: Boolean,
      default: false
    },
    eventType: {
      type: [String, Number],
      default: ''
    }
  },
  components: {
    XuSelect: () => import('@/components/XuSelect')
  },
  data () {
    return {
      activeNames: ['1', '2'],
      eventSd: {
        warmUp: '',
        sellInStoreCount: '',
        projectSalePredict: []
      },
      warmUpList: [
        { label: this.$t('shared.filter.high'), value: 'High' },
        { label: this.$t('shared.filter.average'), value: 'Average' },
        { label: this.$t('shared.filter.low'), value: 'Low' }
      ],
      formFourData: {
        isPreStore: '',
        isWarmUp: '',
        warmUpType: '',
        advanceDay: ''
      },
      radioList: [
        { label: this.$t('shared.filter.yes'), value: true },
        { label: this.$t('shared.filter.no'), value: false }
      ]
    }
  },
  methods: {
    checkVerify () {
      return true
    },
    editEcho (data) {
      if (this.eventType === 2) {
        this.eventSd.projectSalePredict = data.projectSalePredict.map(subItem => {
          return { projectName: subItem.projectName, projectId: subItem.projectId, sales: subItem.sales || '', inventory: subItem.inventory || '' }
        })
      } else {
        Object.keys(this.formFourData).forEach(subItem => {
          this.formFourData[subItem] = data[subItem]
        })
      }
    },
    handleStep (delta, params, typeKey, obj = {}) {
      if (obj.checkInventory) {
        let newQuantity = (Number(params[typeKey]) || 0) + delta
        if (newQuantity < 0) {
          newQuantity = 0
        }
        const newInventory = params.originalInventoryCount - newQuantity
        this.$set(params, typeKey, newQuantity)
        this.$set(params, 'inventoryCount', newInventory)
      } else {
        let newQuantity = (Number(params[typeKey]) || 0) + delta
        if (newQuantity < 0) {
          newQuantity = 0
        }
        this.$set(params, typeKey, newQuantity)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.step-four {
  .visit-form-content {
    /deep/.van-collapse {
      .van-collapse-item {
        background-color: #fff;
        .van-collapse-item__title {
          background-color: #e8effc;
          font-weight: bold;
          padding: 5px 10px;
          margin-bottom: 2px;
          .van-cell__title {
            font-weight: bold;
            > span {
              font-size: 14px;
            }
          }
        }
        .van-collapse-item__content {
          padding: 0px;
          padding-top: 10px;
        }
      }
      &::after {
        border: none;
      }
    }
    .top-title {
      display: flex;
      font-weight: bold;
      color: #000;
      font-size: 12px;
      margin-bottom: 10px;
      padding: 0 10px;
      .ell-icon {
        margin-top: 2px;
        width: 11px;
        height: 11px;
        margin-right: 5px;
      }
    }
    .form-item {
      // padding: 0 10px;
      margin-bottom: 20px;
      .label {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #333;
        margin-bottom: 8px;
        // 添加必填标记样式
        &.required {
          position: relative;
          padding-left: 12px; // 为星号预留空间
          &::before {
            content: '*';
            color: #ff4444;
            position: absolute;
            left: 0;
            top: 0;
            font-size: 14px;
            line-height: 1;
          }
        }
        &.square {
          font-weight: bold;
          &::before {
            content: '';
            width: 8px;
            height: 8px;
            background-color: #307bff;
            // position: absolute;
            // left: 0;
            // top: 0;
            transform: rotate(45deg);
            margin-right: 5px;
          }
        }
        .label-icon {
          width: 16px;
          height: 16px;
          margin-left: 3px;
        }
      }
      .order-type-label {
        font-size: 13px;
      }
      .label-bottom {
        padding-bottom: 8px;
        border-bottom: 1px solid #ebedf0;
      }
      .custom-field {
        padding: 5px 10px;
        background: #fff;
        border: 1px solid #b9cbed;
        border-radius: 4px;
        font-size: 12px;
        &::placeholder {
          color: #999;
        }
      }
      .custom-radio-field {
        padding: 0;
        font-size: 12px;
        border: none;
      }
      .product-quantity {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        .chiledren-label {
          margin-left: 16px;
          margin-right: 5px;
          font-size: 12px;
          color: #333;
        }
        .custom-xu-select {
          width: 166px;
        }
        .half-field {
          flex: 1;
        }
      }
      .product-sales {
        .product-mode {
          display: flex;
          align-items: center;
        }
        .mode-label {
          flex: 1;
          margin-right: 10px;
          font-size: 12px;
          color: #333;
          &::before {
            content: '#';
            width: 8px;
            height: 8px;
            color: #307bff;
            margin-right: 5px;
          }
        }
        .xu-custom-select {
          width: 210px;
        }
      }
      .del-img {
        width: 20px;
        height: 20px;
        margin-left: 5px;
      }
      .product-desc {
        margin: 10px 0;
        padding: 10px;
        background-color: #f7f7f7;
        border-radius: 10px;
        .quantity-form {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .quantity-form,
        .area-form {
          .form-label {
            font-size: 12px;
            color: #7f7f7f;
          }
        }
        .area-form {
          margin-top: 8px;
        }
      }
      .brand-item {
        font-size: 12px;
        margin-bottom: 10px;
      }
      .product-status {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .product-listing {
        padding: 10px;
        margin-top: 10px;
        background-color: #f7f7f7;
        border-radius: 10px;
        .listing-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 5px;
          .listing-label {
            font-size: 13px;
            color: #333;
          }
          /deep/.van-cell {
            width: auto;
          }
          .custom-radio-field {
            background-color: #f7f7f7;
          }
        }
        .listing-title {
          margin-top: 10px;
          font-size: 13px;
          color: #7f7f7f;
        }
        .listing-product {
          .checkout-custom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;
            font-size: 12px;
            color: #7f7f7f;
            /deep/.van-checkbox__label {
              color: #7f7f7f;
            }
            .total-pcs {
              color: #307bff;
            }
          }
          .quantity-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            margin-bottom: 5px;
            .title {
              width: 186px;
              &::before {
                content: '#';
                width: 8px;
                height: 8px;
                color: #307bff;
                margin-right: 5px;
              }
            }
          }
          /deep/.van-checkbox {
            .van-checkbox__label {
              margin-left: 3px;
            }
            .van-checkbox__icon {
              height: auto;
            }
            // .van-icon {
            //   width: 16px;
            //   height: 16px;
            //   font-size: 12px;
            // }
          }
        }
      }
      .is-Direct {
        .quantity-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          margin-bottom: 5px;
          .title {
            width: 186px;
            &::before {
              content: '#';
              width: 8px;
              height: 8px;
              color: #307bff;
              margin-right: 5px;
            }
          }
        }
        /deep/.van-collapse {
          .van-collapse-item__title {
            padding: 0;
            font-size: 12px;
            background-color: #f7f7f7;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            margin-bottom: 0;
          }
          .van-collapse-item__title--expanded::after {
            display: none;
          }
          .van-collapse-item__content {
            padding: 10px;
            font-size: 12px;
            background-color: #f7f7f7;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
          }
          .van-cell__right-icon {
            right: 10px;
            top: 2px;
          }
        }
        /deep/.van-hairline--top-bottom::after {
          display: none;
        }
      }
      .stepper-custom,
      .total-count {
        display: flex;
        align-items: center;
        border: 1px solid #b9cbed;
        border-radius: 4px;
        overflow: hidden;
        .step-btn {
          width: 28px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #fff;
          color: #333333;
          cursor: pointer;
          border-right: 1px solid #b9cbed;;
          font-size: 12px;
          &:last-child {
            border-right: none;
          }
          &:active {
            background-color: #f2f3f5;
          }
        }
        .step-value {
          width: 32px;
          height: 24px;
          padding: 0;
          background-color: #fff;
          border-right: 1px solid #b9cbed;
          border-radius: 0;
          /deep/ .van-field__control {
            text-align: center;
            height: 24px;
            line-height: 24px;
            color: #323233;
            font-size: 12px;
          }
        }
      }
      .total-count {
        border: none;
      }
      .phone-inputs {
        display: flex;
        align-items: center;
        .custom-field {
          flex: 1;
          text-align: center;
        }
        span {
          margin: 0 5px;
        }
      }
      /deep/.van-uploader {
        .van-uploader__upload {
          width: 60px;
          height: 60px;
        }
        .van-uploader__preview-image {
          width: 60px;
          height: 60px;
        }
      }
    }
    .add-more {
      padding: 0 10px;
      color: #307bff;
      font-size: 12px;
      margin-bottom: 20px;
    }
  }
  .form-item {
    padding: 0 10px;
    margin-bottom: 13px;
    .label {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #333;
      margin-bottom: 8px;
      // 添加必填标记样式
      &.required {
        position: relative;
        padding-left: 12px; // 为星号预留空间
        &::before {
          content: '*';
          color: #ff4444;
          position: absolute;
          left: 0;
          top: 0;
          font-size: 14px;
          line-height: 1;
        }
      }
      .label-icon {
        width: 16px;
        height: 16px;
        margin-left: 3px;
      }
    }
    .custom-field {
      padding: 5px 10px;
      background: #fff;
      border: 1px solid #b9cbed;
      border-radius: 4px;
      font-size: 12px;
      &::placeholder {
        color: #999;
      }
    }
    .custom-radio-field {
      padding: 0;
      font-size: 13px;
      border: none;
    }
    .phone-inputs {
      display: flex;
      align-items: center;
      .custom-field {
        flex: 1;
        text-align: center;
      }
      span {
        margin: 0 5px;
      }
    }
  }
}
</style>
